import React from "react";

const Header = () => {
  return (
    <header
      className="w-full py-4 px-6 shadow-md"
      style={{ backgroundColor: "#2f80ed" }}
    >
      <div className="flex items-center">
        <img src="/logo.png" alt="Pencil Logo" className="h-8 w-auto" />
      </div>
    </header>
  );
};

export default Header;
